import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import { Unstable_Grid2 as Grid } from "@mui/material";
export var SelectChevron = function(props) {
    return /*#__PURE__*/ _jsx(Grid, {
        alignItems: "center",
        className: props.className,
        display: "flex",
        height: "1em",
        children: /*#__PURE__*/ _jsx(ArrowDropDownOutlined, {})
    });
};

//# sourceMappingURL=SelectChevron.js.map